import EFPicture from 'elem/compCommon/EFPicture';
import SolarPanel from '@elem/SVGIcon/CostSaving/SolarPanel';
import Capacity from '@elem/SVGIcon/CostSaving/Capacity';
import Installation from '@elem/SVGIcon/CostSaving/Installation';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('costsaving');
    const icons: any = [
        {
            icon: <SolarPanel />,
            text: t('secE_icon1'),
        },
        {
            icon: <Capacity />,
            text: t('secE_icon2'),
        },
        {
            icon: <Installation />,
            text: t('secE_icon3'),
        },
    ];
    return (
        <div id="cost-saving-E" className={`cost-saving-E cost-saving-box ${css['cost-saving-E']}`}>
            <div className="content-box">
                <div className="img-box">
                    <EFPicture
                        src={`${
                            locale === 'za'
                                ? 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719544841954/1920-03.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1744940977460/Frame%20161269540%20(1).jpg'
                        }`}
                        srcMobile={`${
                            locale === 'za'
                                ? 'https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1719545025237/375-01.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1744940668858/pic%20(1).png'
                        }`}
                        alt={t('secE_title')}
                    />
                </div>
                <div className="text-info">
                    <h2 className="title white">{t('secE_title')}</h2>
                    <p className="desc s">{t('secE_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text li">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
